// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_Gf","dots":"e_Hf"};